var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
import * as React from 'react';
import styled from 'styled-components';
import { Flex } from '@vital-ui/react-utils';
import { CloseIcon } from './icon/CloseIcon';
var Root = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #ffffff;\n  border-color: transparent;\n  background-color: ", ";\n  border-radius: ", ";\n  line-height: 1;\n  margin: 4px 0 4px 5px;\n  padding: ", ";\n  font-weight: 400;\n  align-items: center;\n  overflow: hidden;\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  color: #ffffff;\n  border-color: transparent;\n  background-color: ", ";\n  border-radius: ", ";\n  line-height: 1;\n  margin: 4px 0 4px 5px;\n  padding: ", ";\n  font-weight: 400;\n  align-items: center;\n  overflow: hidden;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.select.tag.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.select.tag.borderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.select.tag.padding;
}, function (_a) {
    var theme = _a.theme;
    return theme.select.tag.hoverBg;
});
var Content = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var noop = function () { };
export var Tag = function (_a) {
    var children = _a.children, onClick = _a.onClick, onCloseClick = _a.onCloseClick, props = __rest(_a, ["children", "onClick", "onCloseClick"]);
    return (React.createElement(Root, __assign({ onClick: onClick }, props),
        React.createElement(Content, null, children),
        onCloseClick && (React.createElement(CloseIcon, { onClick: onCloseClick, name: "close", color: "#fff", fontSize: 13 }))));
};
Tag.defaultProps = {
    onClick: noop,
    onCloseClick: noop,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tag.js.map